import { Modal } from "antd";
import { useState } from "react";
import { useStripe, useElements, CardElement } from "@stripe/react-stripe-js";
import { startCall } from "../apis/callingAPis";
import { toast } from "react-toastify";
import { useAuth } from "../context/authContext";
import Cookies from "js-cookie";

const CardPaymentModal = ({
  iscardpaymentModalOpen,
  showcardPaymentModal,
  showoutboundModal,
}) => {
  const { username, email, customerId, clientSecret, agenid } = useAuth();

  const stripe = useStripe();
  const elements = useElements();
  // const [clientSecret, setClientSecret] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  console.log(agenid);
  // const fetchClientSecret = async () => {
  //   const agentId = "3X5LBEVlKcVj7sjX4bnS";
  //   const res = await startCall(username, email, agentId, customerId);
  //   console.log(res);
  // };
  // useEffect(() => {
  //   if (email) {
  //     fetchClientSecret();
  //   }
  // }, [iscardpaymentModalOpen]);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (elements == null) {
      return;
    }

    // Trigger form validation and wallet collection
    const { error: submitError } = await elements.submit();
    if (submitError) {
      console.log(submitError);
      setErrorMessage(submitError.message);
      return;
    }
    const cardElement = elements.getElement(CardElement);

    const result = await stripe.confirmCardSetup(clientSecret, {
      payment_method: {
        card: cardElement,
        billing_details: { name: username, email: email },
      },
    });
    console.log(result, "result");
    const setupIntentStatus = result?.setupIntent?.status;

    if (setupIntentStatus === "succeeded") {
      showoutboundModal();
      showcardPaymentModal();
    } else {
      setErrorMessage("Card setup failed. Please try again.");
      toast.error("Card setup failed. Please try again.");
    }
    console.log(result);
  };

  return (
    <div>
      <Modal
        open={iscardpaymentModalOpen}
        onCancel={showcardPaymentModal}
        centered
        footer={null}
        className="white-payment-modal"
      >
        {clientSecret && (
          <>
            <form onSubmit={handleSubmit}>
              <div className="card-input">
                <label htmlFor="card" className="card-label">
                  Enter your card details
                </label>
                <CardElement id="card" />
              </div>
              <div className="card-div">
                <button
                  type="submit"
                  disabled={!stripe}
                  className="cardbtn-primary"
                >
                  Submit
                </button>
              </div>
            </form>
          </>
        )}
      </Modal>
    </div>
  );
};

export default CardPaymentModal;
